export default __webpack_public_path__ + "assets/images/a01470a6aa531b5d5c70f700e8282076.png";